var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon24PxGlobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "4-icon-24-px-globe"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3a9 9 0 100 18 9 9 0 000-18zM9.723 5.379A7.009 7.009 0 005.07 11h2.786a13.24 13.24 0 011.866-5.621zm4.554 0A13.24 13.24 0 0116.143 11h2.786a7.009 7.009 0 00-4.652-5.621zM14.132 11A11.241 11.241 0 0012 5.572 11.24 11.24 0 009.868 11h4.264zm-4.264 2h4.264A11.241 11.241 0 0112 18.428 11.24 11.24 0 019.868 13zm-2.011 0H5.07a7.008 7.008 0 004.652 5.621A13.24 13.24 0 017.857 13zm6.42 5.621A13.24 13.24 0 0016.143 13h2.786a7.008 7.008 0 01-4.652 5.621z",
    className: "\\xF0\\x9F\\x8E\\xA8 Color",
    clipRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon24PxGlobe);
export default __webpack_public_path__ + "static/media/4-icon-24-px-globe.ff4e8d9f.svg";
export { ForwardRef as ReactComponent };